import api from '@/api'

export default {
  namespaced: true,
  state: {
    formData: {
      paymentMethod: {},
      payPartMonth: null,
      legalPersonInfo: {}
    },
    paymentMethods: [],
    pending: true,
    isOpen: false
  },
  getters: {
    isPaymentFormValid (state, getters, rootState) {
      if (state.formData.paymentMethod.id === '3') {
        if (rootState.checkout.loadingComponents?.legalPersonPayment) {
          return false
        }
        if (state.formData.legalPersonInfo.hasOwnProperty('status') && state.formData.legalPersonInfo.status === 'error') {
          return false
        }
        if (state.formData.legalPersonInfo.inn && state.formData.legalPersonInfo.inn.length < 10) {
          return false
        }
        // если филия валидируем + 2 поля
        if (state.formData.legalPersonInfo?.formRef === '82a553c6-4f94-11e8-a3de-005056b2fc3d') {
          return state.formData.legalPersonInfo.egr && state.formData.legalPersonInfo.firmEgr && state.formData.legalPersonInfo.firmTitle
        }
        return state.formData.legalPersonInfo.inn || state.formData.legalPersonInfo.egr
      } else {
        return Object.keys(state.formData.paymentMethod).length
      }
    }
    // isDeliveryFormValid (state) {
    //   if (state.formData.deliveryMethod.method_id === 2 || state.formData.deliveryMethod.method_id === 4 || state.formData.deliveryMethod.method_id === 6) {
    //     const arrayOfErrors = Object.values(state.courierDataErrors)
    //     const errorsStr = arrayOfErrors.reduce((acc, curr) => acc + curr, '')
    //     return !errorsStr.length && state.formData.courierData.street && state.formData.courierData.entrance && state.formData.courierData.house
    //   } else {
    //     return Object.keys(state.formData.selectedSpot).length > 0
    //   }
    // }
  },
  mutations: {
    SET_DATA (state, data) {
      state.formData = { ...state.formData, ...data }
      localStorage.setItem('paymentNewData', JSON.stringify(state.formData))
    },
    SET_OPEN (state, data) {
      state.isOpen = data
    },
    SET_PENDING (state, data) {
      state.pending = data
    },
    SET_LEGAL_PERSON_INFO (state, data) {
      state.formData.legalPersonInfo = data
      localStorage.setItem('paymentNewData', JSON.stringify(state.formData))
    },
    SET_PAYPART_MONTH (state, data) {
      if (!data) {
        state.formData.payPartMonth = null
      }
      state.formData.payPartMonth = data
      localStorage.setItem('paymentNewData', JSON.stringify(state.formData))
    },
    SET_PAYMENT_METHODS (state, data) {
      state.paymentMethods = data
    },
    SET_PAYMENT_METHOD (state, data) {
      state.formData.paymentMethod = data
      localStorage.setItem('paymentNewData', JSON.stringify(state.formData))
    }
  },
  actions: {
    SET_PAYMENT_PENDING ({ commit }, data) {
      commit('SET_PENDING', data)
    },
    SET_PAYMENT_IS_OPEN ({ commit }, data) {
      commit('SET_OPEN', data)
    },
    SET_PAYMENT_METHOD ({ commit, dispatch }, data) {
      commit('SET_PAYMENT_METHOD', data)
    },
    SET_LEGAL_PERSON_INFO ({ commit, dispatch }, data) {
      commit('SET_LEGAL_PERSON_INFO', data)
    },
    FETCH_PAYMENT_METHODS ({ commit, dispatch, rootState, state }, data) {
      const params = {}
      commit('SET_PENDING', true)
      if (rootState.deliveryNew.formData.deliveryCity.id) {
        params.cityId = rootState.deliveryNew.formData.deliveryCity.id
      }
      if (rootState.deliveryNew.formData.deliveryMethod.method_id) {
        params.methodId = rootState.deliveryNew.formData.deliveryMethod.method_id
      }
      if (rootState.deliveryNew.formData.selectedSpot.uid) {
        params.storeUid = rootState.deliveryNew.formData.selectedSpot.uid
      }
      api.checkout.getPaymentMethods(params).then(res => {
        commit('SET_PAYMENT_METHODS', res.payments)
        if (!res.payments.find(el => el.id === state.formData.paymentMethod.id)) {
          commit('SET_PAYMENT_METHOD', {})
        }
      }).finally(() => {
        commit('SET_PENDING', false)
      })
    },
    SET_PAYPART_MONTH ({ commit }, data) {
      commit('SET_PAYPART_MONTH', data)
    },
    SET_PAYMENT_DATA ({ commit }, data) {
      commit('SET_DATA', data)
    }
  }
}
